import { useUserContext } from 'providers/user-provider'
import { useMemo } from 'react'

export default function CollaboratorTimelineEmptyState() {
  const { settings } = useUserContext()
  const customBranding = settings?.customBranding

  const emptyImageSrc = useMemo(() => {
    if (customBranding && customBranding?.logo) {
      return customBranding?.logo
    }
    return '/images/icons/thinking_pickle.svg'
  }, [customBranding])

  return (
    <div className="tw-my-4 tw-flex tw-h-auto tw-w-full tw-flex-col tw-items-center tw-justify-center">
      {!!emptyImageSrc && <img src={emptyImageSrc} alt="Empty Image" className="tw-h-auto tw-w-48" />}
      <h4 className="tw-my-0 tw-text-pretty tw-text-center tw-text-xl tw-text-neutral-700">
        It looks like you haven&apos;t added any feedback.
      </h4>
      <p className="tw-my-0 tw-text-pretty tw-text-center tw-text-neutral-700">
        Use the pencil tool or directions input to add feedback to the request owner.
      </p>
    </div>
  )
}
